import { type ReactNode } from 'react';
import ComplexPanelSection from './ComplexPanelSection';
import styles from './PanelSection.module.css';
import SimplePanelSection from './SimplePanelSection';
import type { ComplexPanelSectionProps, SimplePanelSectionProps } from './shared';

type PanelSectionProps = ComplexPanelSectionProps | SimplePanelSectionProps;

function PanelSection(props: ComplexPanelSectionProps): ReactNode;
function PanelSection(props: SimplePanelSectionProps): ReactNode;
function PanelSection(props: PanelSectionProps): ReactNode {
  const { variant } = props;
  return (
    <div className={styles.panelSection}>
      {variant === 'complex' ? (
        <ComplexPanelSection {...props} />
      ) : (
        <SimplePanelSection {...props} />
      )}
    </div>
  );
}

export default PanelSection;
